/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontLayout_viewer$ref = any;
export type StorefrontRefetch_viewer$ref = any;
export type StorefrontRefetch_viewer = {
    readonly " $fragmentRefs": StorefrontLayout_viewer$ref;
    readonly " $refType": StorefrontRefetch_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontRefetch_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontLayout_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '0af1ab8edca5d9d607f872d248fb31a4';
export default node;
